import React from 'react';
import { Helmet } from 'react-helmet-async';

const SeoContainer = ({ pageTitle, metaDescription, metaKeywords, canonical, ogTitle, ogDescription, ogImage, ogUrl }) => {
  console.log('pageTitle', pageTitle);
  // console.log('metaDescription', metaDescription);
  // console.log('metaKeywords', metaKeywords);
  return (
    <Helmet>
      {/* Basic SEO */}
      {pageTitle && <title>{pageTitle}</title>}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}

      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph (OG) for Social Media */}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}

      {/* Twitter Cards */}
      {ogTitle && <meta name="twitter:title" content={ogTitle} />}
      {ogDescription && <meta name="twitter:description" content={ogDescription} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {/* <meta name="twitter:card" content="summary_large_image" /> */}
    </Helmet>
  );
};

export default SeoContainer;